const $sizeGuideTabs = document.querySelectorAll('[data-size-guide-measurements]')

document.querySelector('[data-toggle-size-guide-measurements]').addEventListener('change', (event) => {
    document.querySelectorAll('.size-guide__toggle-label')[0].classList.toggle('checked')
    document.querySelectorAll('.size-guide__toggle-label')[1].classList.toggle('checked')
    $sizeGuideTabs.forEach(($tab) => {
        if (event.target.checked) {
        // show inches
        $tab.style.display = $tab.dataset.sizeGuideMeasurements === 'inches' ? 'block' : 'none';
        } else {
        // show centimeters
        $tab.style.display = $tab.dataset.sizeGuideMeasurements === 'centimeters' ? 'block' : 'none';
        }
    });
});